import React from 'react';
import { SwitchButton, SwitchInput, SwitchLabel } from './styled';
import { Flex } from 'lib/components/styles/layout';
import { CustomSwitchField } from './types';
import { Label } from '../label';

export const BaseSwitch = ({
  name,
  label,
  checked = false,
  disabled = false,
  onChange,
  extendStyles,
  info,
  tooltipPosition,
  ...props
}: CustomSwitchField) => {
  return (
    <Flex
      flexDirection='row'
      width='100%'
      justifyContent='space-between'
      alignItems='center'
      {...extendStyles?.wrapper}
    >
      {label && (
        <Label
          label={label}
          isRequired={false}
          extendStyles={extendStyles?.labelStyles}
          name={`switch-${name}`}
          info={info}
          tooltipPosition={tooltipPosition}
        />
      )}
      <SwitchInput
        {...props}
        type='checkbox'
        id={`switch-${name}`}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <SwitchLabel
        htmlFor={`switch-${name}`}
        isOn={checked}
        disabled={disabled}
      >
        <SwitchButton isOn={checked} />
      </SwitchLabel>
    </Flex>
  );
};
